import { NumberField } from "@base-ui/react";
import React from "react";
import { Icon } from "../../icon";

import "./top-menu-numberfield.css";
import { Tooltip } from "../../tooltip/tooltip";

// There was some custom logic requested that was not in the Base UI component that makes this more complex as needed
// - When Enter is pressed, the cursor must not be blanking anymore (we move set a hidden focus to the root of the component)
// - Input field gets focus, the text must be fully selected so a new value can be entered (also when clicking the input field with the mouse)
export function TopMenuNumberField({
	value,
	min,
	max,
	onChange,
	disabled,
	valueTooltipLabel,
	decrementTooltipLabel,
	incrementTooltipLabel,
}: {
	value: number;
	min: number;
	max: number;
	onChange: (newSize: number) => void;
	disabled?: boolean;
	valueTooltipLabel?: string;
	decrementTooltipLabel?: string;
	incrementTooltipLabel?: string;
}) {
	return (
		<NumberField.Root
			className="top-menu-numberfield"
			value={value}
			min={min}
			max={max}
			step={1}
			tabIndex={-1} /* Allow to set a 'hidden' focus when Enter is pressed */
			allowWheelScrub
			snapOnStep
			smallStep={1}
			disabled={disabled}
			onValueChange={(newValue) => {
				if (newValue !== null) {
					onChange(newValue);
				}
			}}
			onKeyDown={(e) => {
				// Remove blinking cursor by moving focus to a parent element
				if ((e.target as HTMLElement).tagName === "INPUT" && e.key === "Enter") {
					const rootEl = e.currentTarget;
					if (rootEl instanceof HTMLDivElement) {
						rootEl.focus();
					}
				}
			}}
		>
			<NumberField.Group className="top-menu-numberfield__group">
				<Tooltip text={decrementTooltipLabel}>
					<span style={{ display: "inline-flex" }}>
						<NumberField.Decrement
							tabIndex={0}
							className="top-menu-numberfield__btn top-menu-numberfield__btn--decrement"
							onPointerUp={(e) => {
								const parentEl = e.currentTarget.parentElement;
								if (parentEl instanceof HTMLDivElement) {
									parentEl.querySelector("input")?.select();
								}
							}}
						>
							<Icon iconName="minus" />
						</NumberField.Decrement>
					</span>
				</Tooltip>
				<Tooltip text={valueTooltipLabel}>
					<NumberField.Input
						className="top-menu-numberfield__input"
						onFocus={(e) => {
							if (e.currentTarget instanceof HTMLInputElement) {
								e.currentTarget.select();
							}
						}}
						onPointerUp={(e) => {
							if (e.currentTarget instanceof HTMLInputElement) {
								e.currentTarget.select();
								e.preventDefault();
							}
						}}
					/>
				</Tooltip>
				<Tooltip text={incrementTooltipLabel}>
					<span style={{ display: "inline-flex" }}>
						<NumberField.Increment
							tabIndex={0}
							className="top-menu-numberfield__btn top-menu-numberfield__btn--increment"
							onPointerUp={(e) => {
								const parentEl = e.currentTarget.parentElement;
								if (parentEl instanceof HTMLDivElement) {
									parentEl.querySelector("input")?.select();
								}
							}}
						>
							<Icon iconName="plus" />
						</NumberField.Increment>
					</span>
				</Tooltip>
			</NumberField.Group>
		</NumberField.Root>
	);
}
